// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Middleware from '@/middleware'
import Config from '@/common/plugins/config'
import Notice from '@/common/plugins/notice'
import Helpers from '@/common/plugins/helpers'
import options from '@/config'
import MultiLanguage from 'vue-multilanguage'
import Translations from '@/lang'
import {
  MdApp, MdToolbar, MdContent, MdDrawer,
  MdList, MdButton, MdIcon,
  MdTable, MdRipple, MdProgress, MdField, MdCard, MdDialogConfirm, MdDialog, MdEmptyState, MdAutocomplete, MdMenu, MdHighlightText
} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import '@/utils/typedefs'

Vue.config.productionTip = false

Vue.use(Config, options)
Vue.use(Notice)
Vue.use(Helpers)
Vue.use(MultiLanguage, {
  default: 'uk',
  uk: Translations.uk
})

Vue.use(MdApp)
Vue.use(MdToolbar)
Vue.use(MdContent)
Vue.use(MdDrawer)
Vue.use(MdButton)
Vue.use(MdIcon)
Vue.use(MdList)
Vue.use(MdTable)
Vue.use(MdRipple)
Vue.use(MdProgress)
Vue.use(MdField)
Vue.use(MdCard)
Vue.use(MdDialogConfirm)
Vue.use(MdDialog)
Vue.use(MdEmptyState)
Vue.use(MdAutocomplete)
Vue.use(MdMenu)
Vue.use(MdHighlightText)

Middleware(router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js